import { mapEnrollmentError } from "@/helpers/enrollmentErrors";
import { fetchApi } from "@/helpers/fetchApi";

/**
 * Sends one `/multisig/enrollment` write and rethrows any failure as an
 * `EnrollmentError`, whose `message` is safe to render.
 */
export const enrollmentRequest = async <T>(path: string, init: RequestInit): Promise<T> => {
  let response: T | undefined;
  try {
    response = (await fetchApi(path, init)) as T | undefined;
  } catch (err) {
    throw mapEnrollmentError(err);
  }
  // `fetchApi` resolves `undefined` once it has fired the session-expired event.
  if (response === undefined) {
    throw mapEnrollmentError({ message: "", status: 401 });
  }
  return response;
};
